import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { captureAdminApi } from '../api/captureApi';
import { reviewKeys } from '../queryKeys';

export function usePrivateFeedback() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  return useQuery({
    queryKey: reviewKeys.captureFeedback(locationId),
    queryFn: () => captureAdminApi.listFeedback(locationId),
    enabled: !!locationId,
    staleTime: 60 * 1000,
  });
}
